import React, { FC } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

interface ReusableModalProps {
    content: React.ReactNode;
    buttonText: React.ReactNode;
    onclose : ()=> void;
    open : boolean;
   
    
}

const BaseModal: FC<ReusableModalProps> = ({ content, buttonText,onclose,open }) => {
  //const [open, setOpen] = React.useState(false);
  // const handleOpen = () => setOpen(true);
  // const handleClose = () => {setOpen(false);
    // onclose=setOpen(false)
 // };

  return (
    <div style={{display:"inherit"}}>
      <Button className='p-0'style={{ minWidth: "5px", color:'red'}} onClick={onclose}> 
        {buttonText}
      </Button>
      <Modal
        open={open}
        onClose={onclose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {content}
           
        </Box>
      </Modal>
    </div>
  );
};

export default BaseModal;
